import { Tag } from '@billy/design-system'
import { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'

import type { ImportedInvoiceStatus } from '../../types/importedInvoiceStatus'
import { importedInvoiceIntakeStatusToTag } from './constants/importedInvoiceIntakeStatusToTag'

interface ImportedInvoiceIntakeStatusProps {
  status: ImportedInvoiceStatus
}

export const ImportedInvoiceIntakeStatus = ({ status }: ImportedInvoiceIntakeStatusProps): ReactElement | null => {
  const { t } = useTranslation()
  const tag = importedInvoiceIntakeStatusToTag[status]

  if (!tag) {
    return null
  }

  return (
    <Tag color={tag.color} size="md" type="subtle">
      {t(tag.labelKey)}
    </Tag>
  )
}
